// FOR ADD ON ITEM ItemSlider
function addOnItemSliderInit() {
  if (window.innerWidth > 1024) {
    const ItemSlider = document.querySelector('.items');
    let isDown = false;
    let isAnimating = false;
    let startX;
    let scrollLeft;
    let lastX;
    let accumulatedSpeed = 0;
    let frameCount = 0;

    ItemSlider.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - ItemSlider.offsetLeft;
      scrollLeft = ItemSlider.scrollLeft;
      lastX = e.pageX;
    });

    ItemSlider.addEventListener('mouseleave', endScroll);
    ItemSlider.addEventListener('mouseup', endScroll);

    ItemSlider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();

      const x = e.pageX - ItemSlider.offsetLeft;
      const walk = (x - startX) * 1.5;
      const newScrollPosition = scrollLeft - walk;
      accumulatedSpeed += lastX - e.pageX;
      frameCount++;
      lastX = e.pageX;

      if (!isAnimating) {
        window.requestAnimationFrame(() => {
          ItemSlider.scrollLeft = newScrollPosition;
          isAnimating = false;
        });
        isAnimating = true;
      }
    });

    function endScroll() {
      isDown = false;
      let averageSpeed = accumulatedSpeed / frameCount;
      applyMomentum(averageSpeed);
      accumulatedSpeed = 0;
      frameCount = 0;
    }
    function applyMomentum(speed) {
      if (speed === 0) return;
      let friction = 0.95;
      function momentumScroll() {
        if (Math.abs(speed) < 1) return;

        let newScroll = ItemSlider.scrollLeft + speed;
        newScroll = Math.max(
          0,
          Math.min(newScroll, ItemSlider.scrollWidth - ItemSlider.clientWidth)
        );
        ItemSlider.scrollLeft = newScroll;

        if (
          ItemSlider.scrollLeft === 0 ||
          ItemSlider.scrollLeft ===
            ItemSlider.scrollWidth - ItemSlider.clientWidth
        ) {
          speed = 0;
        } else {
          speed *= friction;
        }

        requestAnimationFrame(momentumScroll);
      }
      momentumScroll();
    }
  }
}

// upsellCardFunctionality
function upsellCardInit() {
  const html = document.querySelector('html');
  const body = document.body;
  const addOnItems = document.querySelectorAll('.add-on-item');
  let isDragging = false;
  let startPos = { x: 0, y: 0 };

  function isDrag(start, end) {
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const threshold = 5;
    return dx * dx + dy * dy > threshold * threshold;
  }

  addOnItems.forEach((container) => {
    container.addEventListener('mousedown', (e) => {
      startPos = { x: e.clientX, y: e.clientY };
      isDragging = false;
    });
    container.addEventListener('touchstart', (e) => {
      startPos = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      isDragging = false;
    });

    container.addEventListener('mouseup', (e) => {
      isDragging = isDrag(startPos, { x: e.clientX, y: e.clientY });
    });
    container.addEventListener('touchend', (e) => {
      const touch = e.changedTouches[0];
      isDragging = isDrag(startPos, { x: touch.clientX, y: touch.clientY });
    });

    container.addEventListener('click', function (e) {
      if (isDragging) {
        e.preventDefault();
        return;
      }
      e.stopPropagation();
      const item = container;
      const productId = item.dataset.productId;
      const popupContainer = document.querySelector(
        `.popup-container[data-product-id="${productId}"]`
      );

      if (popupContainer) {
        body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';
        popupContainer.classList.add('show');

        const popupContent = popupContainer.querySelector('.popup-content');
        if (popupContent) {
          popupContent.blur();
          popupContent.addEventListener('click', (event) => {
            event.stopPropagation();
          });
        }
      }
    });
  });

  const closeOverlay = document.querySelectorAll('.popup-overlay');
  closeOverlay.forEach((overlay) => {
    overlay.addEventListener('click', (event) => {
      event.stopPropagation(); // Stop the click event from propagating
      closePopup(event);
    });
  });

  const closeButtons = document.querySelectorAll('.close-popup');
  closeButtons.forEach((btn) => {
    btn.addEventListener('click', closePopup);
  });

  const selectionButtons = document.querySelectorAll('.add-to-kit');
  selectionButtons.forEach((btn) => {
    btn.addEventListener('click', closePopup);
  });

  function closePopup(e) {
    const popupContainer = e.currentTarget.closest('.popup-container');
    if (popupContainer) {
      body.style.overflow = 'auto';
      html.style.overflow = 'auto';
      popupContainer.classList.remove('show');
    }
  }
}

// Upsell Pop Up Card Functions
function upsellPopupCardInit() {
  const mainProductElement = document.querySelector(
    '.add-on-item.main-product'
  );
  const mainProductId = mainProductElement
    ? mainProductElement.getAttribute('data-main_product-id')
    : null;

  let defaultProduct = null;

  if ($('body').hasClass('template-testing')) {
    if(mainProductId == 40455039221929 || mainProductId == "40455039221929") {
      //debugger;
      defaultProduct = {
        id: mainProductId,
        quantity: 1,
        properties: {
          'FREE GIFTS': '1 Ebook + 1 Bledo + 1 Lima Spongy + 1 Nivelador pH. Nosotros agregaremos los productos a tu compra al momento del envío.'
        }
      };
    } else {
      //debugger;
      defaultProduct = {
        id: mainProductId,
        quantity: 1,
      };
    }
  } else {
    defaultProduct = {
      id: mainProductId,
      quantity: 1,
    };
  }

  let productDataAddOns = [defaultProduct];

  const selectionButtons = document.querySelectorAll('.add-to-kit');
  selectionButtons.forEach((btn) => {
    btn.addEventListener('click', function () {
      toggleSelection(btn);
    });
  });

  // fuction handels selection (style changes and text update)
  function toggleSelection(buttonElement) {
    // Get the product ID from the button's data attribute
    const productId = buttonElement.getAttribute('data-product-id');

    // Find the corresponding product block using the product ID
    const productBlock = document.querySelector(
      `.add-on-item[data-product-id="${productId}"]`
    );

    // Toggle the selected status, class, and button text
    if (productBlock.getAttribute('data-selected') === 'false') {
      productBlock.setAttribute('data-selected', 'true');
      productBlock.classList.add('selected-item');
      buttonElement.querySelector('span').textContent = 'Eliminar del kit - '; // Assuming you store price in a data attribute

      // add items to add to cart array request
      productDataAddOns.push({ id: productId, quantity: 1 });
    } else {
      productBlock.setAttribute('data-selected', 'false');
      productBlock.classList.remove('selected-item');
      buttonElement.querySelector('span').textContent = 'Añadir al kit - '; // Assuming you store price in a data attribute

      // remove item from add to cart array
      productDataAddOns = productDataAddOns.filter(
        (product) => product.id !== productId
      );
    }

    updateButtonsTotal();
  }

  function addToKitCart(productDataAddOns) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: productDataAddOns, // Pass the array of product data as 'items'
      },
      dataType: 'json',
      success: function () {
        // Notify user of success (optional)
      },
      error: function () {
        // Notify user of an error
      },
    });
  }

  document
    .querySelector('.add-items-to-cart')
    .addEventListener('click', function () {
      addToKitCart(productDataAddOns);
    });

  document
    .querySelector('.sticky-add-button')
    .addEventListener('click', function () {
      addToKitCart(productDataAddOns);
    });
}

function calculateTotal() {
  // Get main product's price
  const mainProductPrice = parseFloat(
    document
      .querySelector('.main-product')
      .getAttribute('data-main_product-price')
  );

  // Get all the add-on items that are selected
  const selectedAddOns = document.querySelectorAll(
    '.add-on-item[data-selected="true"]'
  );

  // Calculate total for the selected add-on items
  let addOnsTotal = 0;
  selectedAddOns.forEach((addOn) => {
    addOnsTotal += parseFloat(addOn.getAttribute('data-item-price'));
  });

  console.log(mainProductPrice)
  console.log(addOnsTotal)
  // Calculate the grand total
  const grandTotal = mainProductPrice + addOnsTotal;

  return grandTotal;
}

function updateButtonsTotal() {
  const grandTotal = calculateTotal();

  // Format the total to a currency string - adjust as needed depending on currency and locale
  const formattedTotalRaw = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(grandTotal);

  // Add a space after the currency symbol
  const formattedTotal = formattedTotalRaw.replace('$', '$ ');
console.log(formattedTotalRaw)
  // Update the buttons
  document.querySelector('.sticky-add-button span').textContent =
    'Añadir al carrito - ' + formattedTotal;
  document.querySelector('.add-items-to-cart span').textContent =
    'Añadir al carrito - ' + formattedTotal;
}

// Call the function initially to set the initial total

// ALL FUNCTION INIT RUN HERE
$(document).ready(function () {
  // resposible for ItemSlider / click n drag functianalty
  addOnItemSliderInit();
  upsellCardInit();
  upsellPopupCardInit();
  /*setTimeout(function() {
    upsellPopupCardInit();
  }, 400);*/
  updateButtonsTotal();
});
